<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/products">Products</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">{{ this.$store.state.product.name }}</a></li>
      </ul>
    </nav>

    <div class="columns">
      <div class="column is-4 is-offset-1">
        <p class="title is-4">{{ this.$store.state.product.name }}</p>
        <p><span class="has-text-grey">Product ID:</span> {{ $route.params.product_id }}</p>
        <p><span class="has-text-grey">Slug:</span> {{ this.$store.state.product.slug }}</p>
        <p><span class="has-text-grey">Created at:</span> {{ this.$store.state.product.created_at }}</p>
        <p><span class="has-text-grey">Updated at:</span> {{ this.$store.state.product.updated_at }}</p>
      </div>
      <div class="column is-2">
        <nav class="level">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Smart things total</p>
              <router-link v-bind:to="`/products/${this.$store.state.product.id}/things`">
                <p class="subtitle is-4 has-text-primary">{{ this.$store.state.productThingsTotal | numberDisplay }}</p>
              </router-link>
            </div>
          </div>
        </nav>
      </div>
      <div class="column is-2">
        <nav class="level">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Firmware updates</p>
              <router-link v-bind:to="`/products/${this.$store.state.product.id}/fw_updates`">
                <p class="subtitle is-4 has-text-primary">{{ this.$store.state.fwUpdatesTotal | numberDisplay }}</p>
              </router-link>
            </div>
          </div>
        </nav>
      </div>
      <div class="column is-4 is-offset-1">
        <div class="control is-grouped">
          <div class="control">
            <router-link v-bind:to="`/products/${this.$store.state.product.id}/edit`" class="button is-primary is-outlined">
              <span class="icon"><i class="fa fa-lg fa-pencil"></i></span>
              <span>Edit</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    created () {
      this.$store.dispatch('getProduct', {
        productId: this.$route.params.product_id
      })
      this.$store.dispatch('getProductThings', {
        productId: this.$route.params.product_id,
        params: { limit: 1 }
      })
      this.$store.dispatch('getProductFwUpdates', {
        productId: this.$route.params.product_id,
        params: { limit: 1 }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// ProductView.vue?e53c3696